class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];

    if (document.getElementById('cart-priority-checkout-slot')) {
      sections.splice(1, 0, {
        id: 'cart-priority-checkout-slot',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-priority-checkout',
      });
    }

    return sections;
  }

  syncStickyCheckout(parsedState) {
    const stickyCheckout = document.querySelector('.cart-sticky-checkout');
    if (!stickyCheckout) return;

    if (parsedState.item_count === 0) {
      stickyCheckout.remove();
      return;
    }

    const stickyTotal = stickyCheckout.querySelector('.cart-sticky-checkout__total');
    const currentTotal =
      document.querySelector('#main-cart-footer .totals__amount') ||
      document.querySelector('#main-cart-footer .totals__subtotal-value');
    if (stickyTotal && currentTotal) stickyTotal.textContent = currentTotal.textContent.trim();
  }

  syncPriorityCheckout(parsedState) {
    const items = Array.isArray(parsedState.items) ? parsedState.items : [];
    const hasOutdoorMist = items.some((item) => item.handle === 'outdoor-mist');
    const hasSubscription = items.some((item) => Boolean(item.selling_plan_allocation));
    const cartRoot = document.querySelector('cart-items');
    if (cartRoot) {
      cartRoot.setAttribute('data-cart-item-count', String(parsedState.item_count || 0));
      cartRoot.setAttribute('data-cart-total', String(parsedState.total_price || 0));
      cartRoot.setAttribute('data-cart-has-outdoor-mist', hasOutdoorMist ? 'true' : 'false');
      cartRoot.setAttribute('data-cart-has-subscription', hasSubscription ? 'true' : 'false');
    }

    document.querySelectorAll('.cart-checkout-guide__konbini').forEach((el) => {
      el.hidden = hasSubscription || parsedState.item_count === 0;
    });

    document.querySelectorAll('.cart-checkout-guide__credit-only').forEach((el) => {
      el.hidden = !hasSubscription || parsedState.item_count === 0;
    });

    const priorityCheckout = document.querySelector('.cart-priority-checkout');
    if (!priorityCheckout) return;

    if (parsedState.item_count === 0 || !hasOutdoorMist) {
      priorityCheckout.remove();
      return;
    }

    const priorityTotal = priorityCheckout.querySelector('.cart-priority-checkout__total');
    if (priorityTotal) {
      priorityTotal.textContent = '合計 ¥' + Math.round((parsedState.total_price || 0) / 100).toLocaleString('ja-JP');
    }
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text().then((text) => ({ ok: response.ok, status: response.status, text }));
      })
      .then(({ ok, status, text }) => {
        let parsedState;
        try {
          parsedState = JSON.parse(text);
        } catch (e) {
          throw new Error('Invalid cart response');
        }
        // Shopify は在庫不足等で 422 + {status, description, errors} を返す
        if (!ok || parsedState.status) {
          const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
          const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          if (lineItemError) {
            const msg = parsedState.description || parsedState.message || window.cartStrings.error;
            const errTextEl = lineItemError.querySelector('.cart-item__error-text');
            if (errTextEl) errTextEl.textContent = msg;
            lineItemError.querySelector('.icon-error').classList.remove('hidden');
          }
          if (quantityElement) quantityElement.value = quantityElement.getAttribute('value') || quantityElement.defaultValue;
          this.disableLoading();
          return;
        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const sectionHtml = parsedState.sections[section.section];
          const sectionContainer = document.getElementById(section.id);
          if (!sectionHtml || !sectionContainer) return;

          const elementToReplace =
            sectionContainer.querySelector(section.selector) || sectionContainer;
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(sectionHtml, section.selector);
        }));

        this.syncStickyCheckout(parsedState);
        this.syncPriorityCheckout(parsedState);
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};

/* Content-blocker / wallet SDK 破壊時のフォールバック:
   AdGuard / uBlock 等が Shopify の portable-wallets SDK を遮断すると
   handleUnrecognizedUser → cleanup が走り checkout ボタンが反応しなくなる。
   通常 submit が成功すれば pagehide / beforeunload で timer を消すため
   二重ナビゲーションは起きない。発火時のみ dataLayer + console.warn に残す。 */
(function () {
  if (window.__maimaCheckoutFallback) return;
  window.__maimaCheckoutFallback = true;

  var WALLET_SELECTOR = [
    '[data-cart-wallets-panel]',
    '.cart__dynamic-checkout-buttons',
    '.shopify-payment-button',
    '[data-shopify="payment-button"]',
    'shopify-accelerated-checkout-cart',
    'shop-pay-wallet-button',
    'google-pay-wallet-button',
    'apple-pay-wallet-button'
  ].join(',');

  var CART_CONTEXT_SELECTOR = [
    '#cart',
    '#CartDrawer-Form',
    '#cart-notification-form',
    'cart-items',
    'cart-drawer',
    'cart-notification',
    '.cart-sticky-checkout',
    '.cart__footer-wrapper'
  ].join(',');

  var CHECKOUT_INTENT_KEY = 'maima:checkout-intent';
  var CHECKOUT_INTENT_TTL_MS = 8000;
  var navTimer = null;
  var navigating = false;

  function cancelTimer() {
    if (navTimer) { clearTimeout(navTimer); navTimer = null; }
  }

  function isCartCheckoutTarget(btn) {
    if (!btn) return false;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return false;
    if (btn.closest(WALLET_SELECTOR)) return false;
    return Boolean(btn.closest(CART_CONTEXT_SELECTOR));
  }

  function isCartPath(pathname) {
    var path = (pathname || location.pathname).replace(/\/+$/, '');
    return path === '/cart';
  }

  function getNavigationType() {
    try {
      var entries = performance.getEntriesByType && performance.getEntriesByType('navigation');
      return entries && entries[0] && entries[0].type;
    } catch (err) {
      return '';
    }
    return '';
  }

  function clearCheckoutIntent() {
    try { window.sessionStorage.removeItem(CHECKOUT_INTENT_KEY); } catch (err) {}
  }

  function readCheckoutIntent() {
    try {
      var raw = window.sessionStorage.getItem(CHECKOUT_INTENT_KEY);
      if (!raw) return null;
      var intent = JSON.parse(raw);
      if (!intent || !intent.expiresAt || intent.expiresAt < Date.now()) {
        clearCheckoutIntent();
        return null;
      }
      return intent;
    } catch (err) {
      clearCheckoutIntent();
      return null;
    }
  }

  function writeCheckoutIntent() {
    try {
      var now = Date.now();
      window.sessionStorage.setItem(CHECKOUT_INTENT_KEY, JSON.stringify({
        createdAt: now,
        expiresAt: now + CHECKOUT_INTENT_TTL_MS,
        sourcePath: location.pathname
      }));
    } catch (err) {}
  }

  function triggerCheckoutFallback(reason, delayMs) {
    var browserFamily = detectBrowserFamily();
    var vw = window.innerWidth;
    var detail = {
      event: 'maima_checkout_fallback_triggered',
      checkout_fallback_path: location.pathname,
      checkout_fallback_delay_ms: delayMs,
      checkout_fallback_reason: reason,
      browser_family: browserFamily,
      in_app_browser: detectInAppBrowser(),
      viewport_height: window.innerHeight,
      // GA4 送信 (cta-analytics の sendMappedGa4) が使う共通フィールド
      // (cta-analytics の basePayload と同等) を fallback でも揃える
      page_url: window.location.href,
      viewport_width: vw,
      device_type: vw < 768 ? 'mobile' : (vw < 1024 ? 'tablet' : 'desktop'),
      ga_client_id: readFallbackGaClientId(),
      ga_session_id: readFallbackGaSessionId()
    };
    var status = { beacon: null, datalayer: false, analytics: false, ga4: false };

    // (1) dataLayer (GTM → GA4)。Content Blocker で死ぬことが多い
    try {
      if (window.dataLayer) { window.dataLayer.push(detail); status.datalayer = true; }
    } catch (err) {}

    // (2) Shopify.analytics (Web Pixel sandbox)。別経路で生き残ることがある
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('maima_checkout_fallback_triggered', detail);
        status.analytics = true;
      }
    } catch (err) {}

    // (2b) GA4 via the page's gtag (snippets/cta-analytics.liquid defines maimaSendGa4)
    try {
      if (typeof window.maimaSendGa4 === 'function') {
        window.maimaSendGa4('maima_checkout_fallback_triggered', detail);
        status.ga4 = true;
      }
    } catch (err) {}

    // (3) cart attributes 経由で確実に注文に残す。sendBeacon が queue できなければ fetch keepalive
    var cartAttrBody = JSON.stringify({
      attributes: {
        maima_fallback: '1',
        maima_fallback_path: location.pathname,
        maima_fallback_browser: browserFamily,
        maima_fallback_reason: reason
      }
    });
    try {
      if (navigator.sendBeacon) {
        var beaconBody = new Blob([cartAttrBody], { type: 'application/json' });
        status.beacon = navigator.sendBeacon('/cart/update.js', beaconBody) ? 'sent' : 'queued_failed';
      } else {
        status.beacon = 'no_api';
      }
    } catch (err) { status.beacon = 'threw'; }

    if (status.beacon !== 'sent') {
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: cartAttrBody
        });
      } catch (err) {}
    }

    clearCheckoutIntent();
    try { console.warn('[Maima] checkout fallback triggered', status, detail); } catch (err) {}
    window.location.assign('/checkout');
  }

  function recoverCheckoutIntent() {
    var intent = readCheckoutIntent();
    if (!intent || !isCartPath(location.pathname)) return;
    if (getNavigationType() === 'back_forward') {
      clearCheckoutIntent();
      return;
    }

    var elapsed = Math.max(0, Date.now() - (intent.createdAt || Date.now()));
    triggerCheckoutFallback('returned_to_cart', elapsed);
  }

  recoverCheckoutIntent();

  window.addEventListener('pagehide', () => { navigating = true; cancelTimer(); });
  window.addEventListener('beforeunload', () => { navigating = true; cancelTimer(); });

  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    var btn = e.target.closest('button[name="checkout"], a[href^="/checkout"], a[href^="/cart/checkout"]');
    if (!isCartCheckoutTarget(btn)) return;

    cancelTimer();
    writeCheckoutIntent();
    navigating = false;
    navTimer = setTimeout(function () {
      if (navigating || document.visibilityState !== 'visible') return;

      triggerCheckoutFallback('stalled_after_click', 2500);
    }, 2500);
  }, false);

  function detectBrowserFamily() {
    var ua = (navigator.userAgent || '').toLowerCase();
    if (/crios/.test(ua)) return 'chrome_ios';
    if (/fxios/.test(ua)) return 'firefox_ios';
    if (/edg\//.test(ua)) return 'edge';
    if (/chrome/.test(ua) && !/edg\//.test(ua)) return 'chrome';
    if (/firefox/.test(ua)) return 'firefox';
    if (/safari/.test(ua) && /version\//.test(ua)) return 'safari';
    if (/safari/.test(ua)) return 'safari_inapp';
    if (/android/.test(ua)) return 'android_other';
    return 'other';
  }

  function detectInAppBrowser() {
    var ua = navigator.userAgent || '';
    // Instagram UA は FB_IAB を併せ持つことがあるため Instagram を先に判定
    if (/Instagram/i.test(ua)) return 'instagram';
    if (/FBAN|FBAV|FB_IAB/i.test(ua)) return 'facebook';
    if (/Line\//i.test(ua)) return 'line';
    return 'none';
  }

  function readFallbackCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function readFallbackGaClientId() {
    var ga = readFallbackCookie('_ga');
    if (!ga) return null;
    var parts = ga.split('.');
    if (parts.length < 4) return null;
    return parts.slice(2).join('.');
  }
  function readFallbackGaSessionId() {
    // G-3BPYPFW8G3 stream。GS1/GS2 両 format から session_id timestamp を抽出
    var raw = readFallbackCookie('_ga_3BPYPFW8G3');
    if (!raw) return null;
    var m = raw.match(/^GS\d+\.\d+\.s?(\d+)/);
    return m ? m[1] : null;
  }
})();
